import { Link } from "@mui/material";

import {
  faqs,
  howItWorks,
  FlyersHamburgerList,
  AdditionalRegistrationInputFields,
} from "./helpers";
import { routes } from "@/global/routes";
import { inventoryTypeUIDs, vendorUUIDs } from "../../constants";
import {
  DefaultRegistrationTerms,
  DefaultCheckoutTerms,
} from "../../default_terms_and_conditions";

import BackgroundImage from "public/images/philadelphiaflyers/flyers.jpg";
import SeatMap3dPreview from "public/images/philadelphiaflyers/seat-map-preview.jpg";
import FindGamesBanner from "public/images/philadelphiaflyers/Philadelphia-Flyers-Flex-Plans.png";

const LogoImage =
  "https://ss-leagues.s3.amazonaws.com/NHL_2024_v3/flyers-assets/Primary%20Logo/NHL_Flyers_Primary.png";

import type { TeamConfig } from "../types";

const config: TeamConfig = {
  teamSchema: "philadelphiaflyers_flex",
  browserTitle: "Flyers Flex Plans",
  packages: false,
  defaultRoute: routes.purchaseSeats,
  phoneNumber: "",
  teamName: "Philadelphia Flyers",

  // seat map configs
  seatMapConfigs: {
    mapId: "blockmap2d",
    venueId: "nam-us-00048-flyers-sec",
    sectionNameMapping: {
      "118": ["118A"],
      "119": ["119A"],
      "120": ["120A"],
      "121": ["121A"],
    },

    hide3dViewFromSlider: true,
    isIoMedia3dViewEnabled: true,
    suiteImages: {
      "101": ["flyers.io-media.com/#/vr/Section/101/14-19/8/d"],
      "102": ["flyers.io-media.com/#/vr/Section/102/1/16/d"],
      "103": ["flyers.io-media.com/#/vr/Section/103/1/7/d"],
      "104": ["flyers.io-media.com/#/vr/Section/104/1/3/d"],
      "105": ["flyers.io-media.com/#/vr/Section/105/10-18/8/d"],
      "106": ["flyers.io-media.com/#/vr/Section/106/1/10/d"],
      "107": ["flyers.io-media.com/#/vr/Section/107/1/6/d"],
      "108": ["flyers.io-media.com/#/vr/Section/108/1/4/d"],
      "109": ["flyers.io-media.com/#/vr/Section/109/1/9/d"],
      "110": ["flyers.io-media.com/#/vr/Section/110/1/3/d"],
      "111": ["flyers.io-media.com/#/vr/Section/111/1/7/d"],
      "112": ["flyers.io-media.com/#/vr/Section/112/1/10/d"],
      "113": ["flyers.io-media.com/#/vr/Section/113/11-19/8/d"],
      "114": ["flyers.io-media.com/#/vr/Section/114/1/10/d"],
      "115": ["flyers.io-media.com/#/vr/Section/115/1/7/d"],
      "116": ["flyers.io-media.com/#/vr/Section/116/1/2/d"],
      "117": ["flyers.io-media.com/#/vr/Section/117/1/4/d"],
      "118": ["flyers.io-media.com/#/vr/Section/118/1/11/d"],
      "118A": ["flyers.io-media.com/#/vr/Section/118A/1-2/12/d"],
      "119": ["flyers.io-media.com/#/vr/Section/119/1/6/d"],
      "119A": ["flyers.io-media.com/#/vr/Section/119A/1-2/9/d"],
      "11thStClub": ["flyers.io-media.com/#/vr/Club/11thStClub/1/1/d"],
      "120": ["flyers.io-media.com/#/vr/Section/120/1/4/d"],
      "120A": ["flyers.io-media.com/#/vr/Section/120A/1-2/12/d"],
      "121": ["flyers.io-media.com/#/vr/Section/121/1/11/d"],
      "121A": ["flyers.io-media.com/#/vr/Section/121A/1-2/11/d"],
      "122": ["flyers.io-media.com/#/vr/Section/122/13-23/6/d"],
      "123": ["flyers.io-media.com/#/vr/Section/123/1/7/d"],
      "124": ["flyers.io-media.com/#/vr/Section/124/1/3/d"],
      "201": ["flyers.io-media.com/#/vr/Section/201/1/7/d"],
      "202": ["flyers.io-media.com/#/vr/Section/202/1/10/d"],
      "203": ["flyers.io-media.com/#/vr/Section/203/1/11/d"],
      "204": ["flyers.io-media.com/#/vr/Section/204/1/6/d"],
      "204A": ["flyers.io-media.com/#/vr/Section/204A/1/7/d"],
      "205": ["flyers.io-media.com/#/vr/Section/205/1/7/d"],
      "205A": ["flyers.io-media.com/#/vr/Section/205A/1/7/d"],
      "206": ["flyers.io-media.com/#/vr/Section/206/1/6/d"],
      "207": ["flyers.io-media.com/#/vr/Section/207/1/9/d"],
      "207A": ["flyers.io-media.com/#/vr/Section/207A/1/9/d"],
      "208": ["flyers.io-media.com/#/vr/Section/208/1/6/d"],
      "209": ["flyers.io-media.com/#/vr/Section/209/1/7/d"],
      "209A": ["flyers.io-media.com/#/vr/Section/209A/1/7/d"],
      "210": ["flyers.io-media.com/#/vr/Section/210/1/7/d"],
      "210A": ["flyers.io-media.com/#/vr/Section/210A/1/6/d"],
      "211": ["flyers.io-media.com/#/vr/Section/211/1/11/d"],
      "212": ["flyers.io-media.com/#/vr/Section/212/1/10/d"],
      "213": ["flyers.io-media.com/#/vr/Section/213/1/7/d"],
      "214": ["flyers.io-media.com/#/vr/Section/214/1/10/d"],
      "215": ["flyers.io-media.com/#/vr/Section/215/1/11/d"],
      "216": ["flyers.io-media.com/#/vr/Section/216/1/6/d"],
      "216A": ["flyers.io-media.com/#/vr/Section/216A/1/7/d"],
      "217": ["flyers.io-media.com/#/vr/Section/217/1/7/d"],
      "217A": ["flyers.io-media.com/#/vr/Section/217A/1/7/d"],
      "218": ["flyers.io-media.com/#/vr/Section/218/1/6/d"],
      "219": ["flyers.io-media.com/#/vr/Section/219/1/9/d"],
      "219A": ["flyers.io-media.com/#/vr/Section/219A/1/9/d"],
      "220": ["flyers.io-media.com/#/vr/Section/220/1/6/d"],
      "221": ["flyers.io-media.com/#/vr/Section/221/1/7/d"],
      "221A": ["flyers.io-media.com/#/vr/Section/221A/1/7/d"],
      "222": ["flyers.io-media.com/#/vr/Section/222/1/7/d"],
      "222A": ["flyers.io-media.com/#/vr/Section/222A/1/6/d"],
      "223": ["flyers.io-media.com/#/vr/Section/223/1/11/d"],
      "224": ["flyers.io-media.com/#/vr/Section/224/1/10/d"],
      BroadStClub: ["flyers.io-media.com/#/vr/Club/BroadStClub/1/1/d"],
      C1: ["flyers.io-media.com/#/vr/Section/C1/1-5/8/d"],
      C10: ["flyers.io-media.com/#/vr/Section/C10/L9-L16/2/d"],
      C10W: ["flyers.io-media.com/#/vr/Section/C10W/ADA/4/d"],
      C11: ["flyers.io-media.com/#/vr/Section/C11/1-7/5/d"],
      C12: ["flyers.io-media.com/#/vr/Section/C12/1-5/9/d"],
      C12W: ["flyers.io-media.com/#/vr/Section/C12W/ADA/5/d"],
      C13: ["flyers.io-media.com/#/vr/Section/C13/1-7/8/d"],
      C14: ["flyers.io-media.com/#/vr/Section/C14/1-7/9/d"],
      C15: ["flyers.io-media.com/#/vr/Section/C15/1-7/4/d"],
      C16: ["flyers.io-media.com/#/vr/Section/C16/L18-L25/2/d"],
      C16W: ["flyers.io-media.com/#/vr/Section/C16W/ADA/4/d"],
      C17: ["flyers.io-media.com/#/vr/Section/C17/24-29/18/d"],
      C1W: ["flyers.io-media.com/#/vr/Section/C1W/ADA/3/d"],
      C2: ["flyers.io-media.com/#/vr/Section/C2/1-7/9/d"],
      C22: ["flyers.io-media.com/#/vr/Section/C22/L26-L33/2/d"],
      C22W: ["flyers.io-media.com/#/vr/Section/C22W/ADA/4/d"],
      C23: ["flyers.io-media.com/#/vr/Section/C23/1-7/5/d"],
      C24: ["flyers.io-media.com/#/vr/Section/C24/1-7/9/d"],
      C3: ["flyers.io-media.com/#/vr/Section/C3/1-7/4/d"],
      C4: ["flyers.io-media.com/#/vr/Section/C4/L1-L8/2/d"],
      C4W: ["flyers.io-media.com/#/vr/Section/C4W/ADA/4/d"],
      CLA: ["flyers.io-media.com/#/vr/ClubSuite/CLA/Exterior/6/d"],
      CLB: ["flyers.io-media.com/#/vr/ClubSuite/CLB/Exterior/6/d"],
      CLC: ["flyers.io-media.com/#/vr/ClubSuite/CLC/Exterior/6/d"],
      CLD: ["flyers.io-media.com/#/vr/ClubSuite/CLD/Exterior/6/d"],
      CLE: ["flyers.io-media.com/#/vr/ClubSuite/CLE/Exterior/6/d"],
      CLF: ["flyers.io-media.com/#/vr/ClubSuite/CLF/Exterior/6/d"],
      CLG: ["flyers.io-media.com/#/vr/ClubSuite/CLG/Exterior/6/d"],
      CLH: ["flyers.io-media.com/#/vr/ClubSuite/CLH/Exterior/8/d"],
      CLI: ["flyers.io-media.com/#/vr/ClubSuite/CLI/Exterior/6/d"],
      CLJ: ["flyers.io-media.com/#/vr/ClubSuite/CLJ/Exterior/6/d"],
      CLK: ["flyers.io-media.com/#/vr/ClubSuite/CLK/Exterior/8/d"],
      CLL: ["flyers.io-media.com/#/vr/ClubSuite/CLL/Exterior/6/d"],
      CLM: ["flyers.io-media.com/#/vr/ClubSuite/CLM/Exterior/6/d"],
      CLN: ["flyers.io-media.com/#/vr/ClubSuite/CLN/Exterior/6/d"],
      CLO: ["flyers.io-media.com/#/vr/ClubSuite/CLO/Exterior/6/d"],
      CLP: ["flyers.io-media.com/#/vr/ClubSuite/CLP/Exterior/6/d"],
      CLQ: ["flyers.io-media.com/#/vr/ClubSuite/CLQ/Exterior/6/d"],
      CLR: ["flyers.io-media.com/#/vr/ClubSuite/CLR/Exterior/6/d"],
      CenterCourt: ["flyers.io-media.com/#/vr/easteregg/CenterCourt/1/1/d"],
      FoulLine: ["flyers.io-media.com/#/vr/easteregg/FoulLine/1/1/d"],
      LL1: ["flyers.io-media.com/#/vr/Section/LL1/1/6/d"],
      LL2: ["flyers.io-media.com/#/vr/Section/LL2/1/6/d"],
      LL3: ["flyers.io-media.com/#/vr/Section/LL3/1/6/d"],
      LL4: ["flyers.io-media.com/#/vr/Section/LL4/1/6/d"],
      LL5: ["flyers.io-media.com/#/vr/Section/LL5/1/6/d"],
      REVROW: ["flyers.io-media.com/#/vr/Section/REVROW/1/17/d"],
      S1: ["flyers.io-media.com/#/vr/Suite/S1/Exterior/8/d"],
      S10: ["flyers.io-media.com/#/vr/Suite/S10/Exterior/7/d"],
      S11: ["flyers.io-media.com/#/vr/Suite/S11/Exterior/7/d"],
      S12: ["flyers.io-media.com/#/vr/Suite/S12/Exterior/7/d"],
      S13: ["flyers.io-media.com/#/vr/Suite/S13/Exterior/7/d"],
      S14: ["flyers.io-media.com/#/vr/Suite/S14/Exterior/7/d"],
      S15: ["flyers.io-media.com/#/vr/Suite/S15/Exterior/7/d"],
      S16: ["flyers.io-media.com/#/vr/Suite/S16/Exterior/7/d"],
      S17: ["flyers.io-media.com/#/vr/Suite/S17/Exterior/7/d"],
      S18: ["flyers.io-media.com/#/vr/Suite/S18/Exterior/7/d"],
      S19: ["flyers.io-media.com/#/vr/Suite/S19/Exterior/7/d"],
      S2: ["flyers.io-media.com/#/vr/Suite/S2/Exterior/8/d"],
      S20: ["flyers.io-media.com/#/vr/Suite/S20/Exterior/8/d"],
      S21: ["flyers.io-media.com/#/vr/Suite/S21/Exterior/7/d"],
      S22: ["flyers.io-media.com/#/vr/Suite/S22/Exterior/7/d"],
      S23: ["flyers.io-media.com/#/vr/Suite/S23/Exterior/8/d"],
      S24: ["flyers.io-media.com/#/vr/Suite/S24/Exterior/7/d"],
      S25: ["flyers.io-media.com/#/vr/Suite/S25/Exterior/7/d"],
      S26: ["flyers.io-media.com/#/vr/Suite/S26/Exterior/7/d"],
      S27: ["flyers.io-media.com/#/vr/Suite/S27/Exterior/7/d"],
      S28: ["flyers.io-media.com/#/vr/Suite/S28/Exterior/7/d"],
      S29: ["flyers.io-media.com/#/vr/Suite/S29/Exterior/7/d"],
      S3: ["flyers.io-media.com/#/vr/Suite/S3/Exterior/8/d"],
      S30: ["flyers.io-media.com/#/vr/Suite/S30/Exterior/7/d"],
      S31: ["flyers.io-media.com/#/vr/Suite/S31/Exterior/7/d"],
      S32: ["flyers.io-media.com/#/vr/Suite/S32/Exterior/7/d"],
      S33: ["flyers.io-media.com/#/vr/Suite/S33/Exterior/7/d"],
      S34: ["flyers.io-media.com/#/vr/Suite/S34/Exterior/7/d"],
      S35: ["flyers.io-media.com/#/vr/Suite/S35/Exterior/7/d"],
      S36: ["flyers.io-media.com/#/vr/Suite/S36/Exterior/7/d"],
      S37: ["flyers.io-media.com/#/vr/Suite/S37/Exterior/8/d"],
      S38: ["flyers.io-media.com/#/vr/Suite/S38/Exterior/8/d"],
      S39: ["flyers.io-media.com/#/vr/Suite/S39/Exterior/8/d"],
      S4: ["flyers.io-media.com/#/vr/Suite/S4/Exterior/8/d"],
      S40: ["flyers.io-media.com/#/vr/Suite/S40/Exterior/8/d"],
      S41: ["flyers.io-media.com/#/vr/Suite/S41/Exterior/8/d"],
      S42: ["flyers.io-media.com/#/vr/Suite/S42/Exterior/8/d"],
      S43: ["flyers.io-media.com/#/vr/Suite/S43/Exterior/8/d"],
      S44: ["flyers.io-media.com/#/vr/Suite/S44/Exterior/8/d"],
      S45: ["flyers.io-media.com/#/vr/Suite/S45/Exterior/8/d"],
      S46: ["flyers.io-media.com/#/vr/Suite/S46/Exterior/8/d"],
      S47: ["flyers.io-media.com/#/vr/Suite/S47/Exterior/8/d"],
      S48: ["flyers.io-media.com/#/vr/Suite/S48/Exterior/7/d"],
      S49: ["flyers.io-media.com/#/vr/Suite/S49/Exterior/7/d"],
      S5: ["flyers.io-media.com/#/vr/Suite/S5/Exterior/8/d"],
      S50: ["flyers.io-media.com/#/vr/Suite/S50/Exterior/7/d"],
      S51: ["flyers.io-media.com/#/vr/Suite/S51/Exterior/7/d"],
      S52: ["flyers.io-media.com/#/vr/Suite/S52/Exterior/7/d"],
      S53: ["flyers.io-media.com/#/vr/Suite/S53/Exterior/7/d"],
      S54: ["flyers.io-media.com/#/vr/Suite/S54/Exterior/7/d"],
      S55: ["flyers.io-media.com/#/vr/Suite/S55/Exterior/7/d"],
      S56: ["flyers.io-media.com/#/vr/Suite/S56/Exterior/7/d"],
      S57: ["flyers.io-media.com/#/vr/Suite/S57/Exterior/7/d"],
      S58: ["flyers.io-media.com/#/vr/Suite/S58/Exterior/7/d"],
      S59: ["flyers.io-media.com/#/vr/Suite/S59/Exterior/7/d"],
      S6: ["flyers.io-media.com/#/vr/Suite/S6/Exterior/8/d"],
      S60: ["flyers.io-media.com/#/vr/Suite/S60/Exterior/7/d"],
      S61: ["flyers.io-media.com/#/vr/Suite/S61/Exterior/8/d"],
      S62: ["flyers.io-media.com/#/vr/Suite/S62/Exterior/7/d"],
      S63: ["flyers.io-media.com/#/vr/Suite/S63/Exterior/7/d"],
      S64: ["flyers.io-media.com/#/vr/Suite/S64/Exterior/8/d"],
      S65: ["flyers.io-media.com/#/vr/Suite/S65/Exterior/7/d"],
      S66: ["flyers.io-media.com/#/vr/Suite/S66/Exterior/7/d"],
      S67: ["flyers.io-media.com/#/vr/Suite/S67/Exterior/7/d"],
      S68: ["flyers.io-media.com/#/vr/Suite/S68/Exterior/7/d"],
      S69: ["flyers.io-media.com/#/vr/Suite/S69/Exterior/7/d"],
      S7: ["flyers.io-media.com/#/vr/Suite/S7/Exterior/7/d"],
      S70: ["flyers.io-media.com/#/vr/Suite/S70/Exterior/8/d"],
      S71: ["flyers.io-media.com/#/vr/Suite/S71/Exterior/7/d"],
      S72: ["flyers.io-media.com/#/vr/Suite/S72/Exterior/7/d"],
      S73: ["flyers.io-media.com/#/vr/Suite/S73/Exterior/7/d"],
      S74: ["flyers.io-media.com/#/vr/Suite/S74/Exterior/7/d"],
      S75: ["flyers.io-media.com/#/vr/Suite/S75/Exterior/7/d"],
      S76: ["flyers.io-media.com/#/vr/Suite/S76/Exterior/7/d"],
      S77: ["flyers.io-media.com/#/vr/Suite/S77/Exterior/7/d"],
      S78: ["flyers.io-media.com/#/vr/Suite/S78/Exterior/8/d"],
      S79: ["flyers.io-media.com/#/vr/Suite/S79/Exterior/8/d"],
      S8: ["flyers.io-media.com/#/vr/Suite/S8/Exterior/7/d"],
      S80: ["flyers.io-media.com/#/vr/Suite/S80/Exterior/8/d"],
      S81: ["flyers.io-media.com/#/vr/Suite/S81/Exterior/8/d"],
      S82: ["flyers.io-media.com/#/vr/Suite/S82/Exterior/8/d"],
      S9: ["flyers.io-media.com/#/vr/Suite/S9/Exterior/7/d"],
    },
  },

  // gift cards
  giftCardConfigs: {
    isMenuGiftCardEnabled: false,
    isLandingPageGiftCardEnabled: false,
    isStandalonePageGiftCardEnabled: false,
    redirectGiftCardUrl: routes.redeem,
  },

  // purchase credit configs
  purchaseCreditConfigs: {
    isLandingPurchaseCreditEnabled: false,
    isStandAlonePurchaseCreditEnabled: false,
    showPurchaseCreditLinkInHomeMenu: false,
    isPurchaseCreditHistoryEnabled: false,
  },

  // disabled routes
  disabledRoutes: [routes.giftCard],

  // switches
  checkoutCreditPackages: false,
  availableCreditEnabled: false,
  isCrowdHandlerEnabled: false,
  inventoryType: inventoryTypeUIDs.seatLevel,

  // purchase seats config
  purchaseSeatConfigs: {
    minGameSelectionCount: 3,
    minSeatLimit: 1,
    isSimilarSeatForAllEvents: true,
    allowManualCartInSimilar: false,
    isCheckoutEditSeatsEnabled: false,
    isDiffSeatAlertEnabled: false,
    defaultSeatCount: 2,
    checkoutTimerEnabled: false,
    isPerksEnabled: true,
  },

  // feature configs
  packageConfigs: {
    isPackageEnabled: false,
    canRemovePackageGames: false,
    staticBuildYourOwn: null,
  },

  // intercom settings
  intercomConfigs: {
    isIntercomEnabled: true,
    allowedPages: [],
  },

  // checkout validations
  checkoutValidation: {
    allowedZipFailCount: Infinity,
    allowedPaymentFailCount: Infinity,
  },

  // analytics configs
  analyticsConfigs: {
    googleAnalyticsId: "",
    attrkPixelId: "",
    beaconId: "",
  },

  // redirect configs
  redirectConfigs: {
    internalRedirectUrl:
      "https://flex.attendevents.com/philadelphiaflyers_gamepacks/events_home",
    externalRedirectUrl: "",
  },

  refreshInventoryWhenEventClick: false,

  isSaveCardAllowed: true,
  manageCard: true,

  // urls
  accountManagerUrl: "https://am.ticketmaster.com/spectacor/",

  // vendor
  platform: vendorUUIDs.ticketmaster,

  // okta config
  oktaIssuer: "",
  oktaClientId: "",

  isBrainTreePaymentEnabled: false,

  // images
  images: {
    logoNameImage: "",
    faviconImage: LogoImage,
    authBackgroundImage: BackgroundImage.src,
    findGamesBannerImage: FindGamesBanner.src,
    seatMap3dPreviewImage: SeatMap3dPreview.src,
    checkoutStatusPageImage: BackgroundImage.src,
    logoImage: LogoImage + "?width=128&height=66",
  },

  uiConfigs: {
    bannerImage: {
      title: "",
      isBackgroundBasedBanner: false,
    },

    featuredGameCard: {
      showLogoWithTitle: false,
      hideOverlayLogo: true,
    },

    bottomBar: {
      showGameSelectionProgress: true,
    },

    gameFiltersSettings: {
      hideAccessibilityFilter: false,
      hideSectionFilter: false,
    },

    shouldDisplayServiceFee: false,
    shouldAddServiceFeeWithPerkPrice: true,

    customAdaLabel: (
      <>
        To purchase accessible seating locations, please contact the Box Office
        at{" "}
        <Link
          href="tel:2152187825"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
        >
          (215) 218-7825
        </Link>
        .
      </>
    ),

    perks: {
      isOpenByDefault: true,
    },

    authPage: {
      registrationForm: {
        additionalInputFields: <AdditionalRegistrationInputFields />,
      },
    },
  },

  colors: {
    primary: "#F74902",
  },

  howItWorks: howItWorks,
  faqs: faqs,

  languages: {
    topNavMenuItems: <FlyersHamburgerList />,
    checkoutTermsAndCondition: <DefaultCheckoutTerms />,
    registrationTermsAndCondition: <DefaultRegistrationTerms />,
    purchaseSeats: {
      progressBarAditionalText: " to continue!",
      progressBarSuccessText:
        "You're good to go! Click continue to view seating options.",
      noSessionsAvailableDescription: (
        <>
          Flex Plans are no longer available for the 2025-26 season. Please
          visit{" "}
          <Link
            sx={{
              color: "primary.main",
              textDecoration: "none",
              fontWeight: 500,
            }}
            href="https://www.nhl.com/flyers/tickets"
            target="_blank"
          >
            Tickets | Philadelphia Flyers
          </Link>{" "}
          to learn more about other ticket opportunities.
        </>
      ),
      noSessionsAvailable: "No games available",
    },
    purchaseGiftCard: null,
    redeemGiftCard: null,

    checkoutSuccessMessage: "Your purchase is complete!",
    checkoutSuccessDescription:
      "Thank you for your Philadelphia Flyers Flex Plans purchase!",

    giftCard: {
      title: "",
      createGiftCard: {
        description: "",
        recipient: {
          sendNowFalse: {
            description: "",
          },
          sendNowTrue: {
            description: "",
          },
        },
      },
      redeemGiftCard: {
        loggedIn: {
          description: "",
        },
        logout: {
          description: "",
        },
        success: {
          description: "",
        },
      },
    },

    signInAuthText:
      "Connect your Ticketmaster account to continue with seamless access.",
  },
};

export default config;
